import React from 'react';
import { Link } from 'react-router-dom';
import useAuthenticatedApi from '../../Authentication/components/hooks/useAuthenticatedApi';

interface ActivationActionsProps {
    row: any;
    onDelete: () => void;
}

export default function ActivationActions({
    row,
    onDelete,
}: ActivationActionsProps) {
    const activationId = row.original.id;
    const authenticatedApi = useAuthenticatedApi();

    const performDelete = () => {
        const deleteRequest = async () => {
            const response = await authenticatedApi.put(
                `activations/${activationId}/archive`
            );

            if (response.status === 200) {
                onDelete();
            }
        };

        const shouldDelete = window.confirm(
            `Are you sure you would like to archive ${row.original.name}`
        );

        if (shouldDelete) {
            deleteRequest();
        }
    };
    return (
        <span className="Table-options">
            <Link to={`${activationId}/edit`}>
                <i className="bi bi-pencil-fill"></i>
            </Link>
            <i onClick={performDelete} className="bi bi-trash3-fill"></i>
        </span>
    );
}
